import { BaseEntity } from "yt-ng-framework";

export class KursDokumentStavka extends BaseEntity{
    constructor(){
        super();
    }    

    KursDokumentID: number = null;
    ValutaID: number = null; 
    //Datum: string = null;
    VredDinS: number = null;
    VredDinP: number = null;
    VredDinK: number = null;
   

    Deserialize(input:any){
        this.ID=input.ID;
        this.KursDokumentID = input.KursDokumentID;
        this.ValutaID = input.ValutaID;       
        this.VredDinS = input.VredDinS;
        this.VredDinP = input.VredDinP;
        this.VredDinK = input.VredDinK;   
        return this;
    }

    Serialize(input:KursDokumentStavka){      
        return input;
    }
}